import { Component } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';

@Component({
  selector: 'app-refund-policy',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './refund-policy.component.html'
})
export class RefundPolicyComponent {}
